import './chart.style.less'

import { Bar } from 'react-chartjs-2'
import MainWrapper from './MainWrapper'
import { useState, useLayoutEffect } from 'react'
interface props {
  title: string
  sign?: string
  showLegend?: boolean
  stacked?: boolean
  data: any
  id: string
  indexAxis?: any
  periods?: string[]
  onPeriodChange?: (period: string) => any
  options?: any
}

function BarChart(props: props) {
  const {
    data,
    showLegend = true,
    title,
    sign = '',
    stacked = false,
    id = '',
    onPeriodChange,
    periods,
    indexAxis = 'x',
  } = props
  const [plugins, setPlugins] = useState<any>()

  useLayoutEffect(() => {
    const plugins = [
      {
        id: 'liveboard',
        beforeInit: function (chart) {
          // Get reference to the original fit function
          const originalFit = chart.legend.fit
          // Override the fit function
          chart.legend.fit = function fit() {
            // Call original function and bind scope in order to use `this` correctly inside it
            originalFit.bind(chart.legend)()
            this.height += 10
          }
        },
      },
    ]

    setPlugins(plugins)
  }, [])

  const options = {
    indexAxis: indexAxis,
    plugins: {
      legend: {
        position: 'top' as const,
        display: showLegend,
        padding: { top: -10 },
        labels: {
          usePointStyle: true,
          pointStyle: 'rectRounded',
        },
      },
      datalabels: {
        formatter: (val) => {
          return val + sign
        },
        anchor: 'end',
        align: 'end',
      },
    },
    layout: {
      padding: { top: 10, left: 20, right: 20, bottom: 20 },
    },
    scales: {
      x: {
        stacked: stacked,
      },
      y: {
        stacked: stacked,
        ticks: {
          callback: function (value) {
            return value + sign
          },
        },
      },
    },
    ...props.options,
  }

  return (
    <MainWrapper
      id={id}
      title={title}
      onPeriodChange={onPeriodChange}
      periods={periods}
    >
      <Bar redraw data={data} options={options} plugins={plugins} />
    </MainWrapper>
  )
}
export default BarChart
